var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10130",
    "data-name": "Group 10130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.77,
    height: 20.829,
    viewBox: "0 0 16.77 20.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4830",
    "data-name": "Rectangle 4830",
    width: 16.77,
    height: 20.829,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10069",
    "data-name": "Group 10069",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M14.6,21.123H2.152a2.547,2.547,0,0,1-2.146-2.4L0,4.7A2.481,2.481,0,0,1,2.436,2.233l1.83-.005,0,1.164A1.962,1.962,0,0,0,6.221,5.381l4.349,0A1.936,1.936,0,0,0,12.5,3.432v-1.2l1.847.007A2.479,2.479,0,0,1,16.77,4.7V18.671A2.543,2.543,0,0,1,14.6,21.123M2.738,9.411l.607.6a.631.631,0,0,0,.87-.041L5.671,8.5A.605.605,0,0,0,4.8,7.662L3.755,8.7l-.187-.178a.615.615,0,0,0-.883.014.625.625,0,0,0,.053.879m10.881.026a.611.611,0,0,0-.042-1.22H7.118a.607.607,0,0,0-.025,1.214ZM2.663,13.676l.62.625a.636.636,0,0,0,.892.016l1.479-1.484A.6.6,0,0,0,4.781,12L3.747,13.027a.529.529,0,0,1-.154-.137.614.614,0,0,0-.868-.075.594.594,0,0,0-.062.861m10.934.086a.594.594,0,0,0,.571-.629.6.6,0,0,0-.6-.581H7.085a.609.609,0,0,0,.033,1.218ZM2.787,18.007l.57.57a.657.657,0,0,0,.936.009L5.73,17.14a.605.605,0,0,0-.855-.857L3.832,17.315a.587.587,0,0,1-.144-.128.61.61,0,1,0-.9.82m10.88.049a.608.608,0,0,0-.008-1.215H7.2a.608.608,0,0,0-.024,1.215Z",
    transform: "translate(0 -0.294)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M11.667,3.865,6.812,3.87a.469.469,0,0,1-.486-.449L6.321,1.467A.471.471,0,0,1,6.767.975L7.845.959A1.494,1.494,0,0,1,9.191,0a1.473,1.473,0,0,1,1.4.954l1.066.017a.472.472,0,0,1,.462.464V3.413a.46.46,0,0,1-.448.452",
    transform: "translate(-0.835 0)",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.c2a783a9e4fe8dae1598093623a57fb9.svg";
export { ForwardRef as ReactComponent };